"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4022],{

/***/ 27492:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// UNUSED EXPORTS: Tiles1, Tiles10, Tiles11, Tiles2, Tiles3, Tiles4, Tiles5, Tiles6, Tiles7, Tiles8, Tiles9

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
;// CONCATENATED MODULE: ./src/components/elements/tiles/Tiles1.tsx


var Tiles1 = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gx-md-5 gy-5 align-items-center",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-md-6",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "row gx-md-5 gy-5",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-10 offset-md-2",
                            children: /*#__PURE__*/ _jsx("figure", {
                                className: "rounded",
                                children: /*#__PURE__*/ _jsx(Image, {
                                    width: 240,
                                    height: 255,
                                    layout: "responsive",
                                    src: "/img/photos/ab1.jpg",
                                    alt: ""
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-12",
                            children: /*#__PURE__*/ _jsx("figure", {
                                className: "rounded",
                                children: /*#__PURE__*/ _jsx(Image, {
                                    width: 290,
                                    height: 225,
                                    layout: "responsive",
                                    src: "/img/photos/ab2.jpg",
                                    alt: ""
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-md-6",
                children: /*#__PURE__*/ _jsx("figure", {
                    className: "rounded",
                    children: /*#__PURE__*/ _jsx(Image, {
                        width: 290,
                        height: 440,
                        layout: "responsive",
                        src: "/img/photos/ab3.jpg",
                        alt: ""
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var tiles_Tiles1 = ((/* unused pure expression or super */ null && (Tiles1)));

;// CONCATENATED MODULE: ./src/components/elements/tiles/Tiles2.tsx

var Tiles2 = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gx-md-5 gy-5",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-md-4 offset-md-2 align-self-end",
                children: /*#__PURE__*/ _jsx("figure", {
                    className: "rounded",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "/img/photos/g1.jpg",
                        srcSet: "/img/photos/g1@2x.jpg 2x",
                        alt: ""
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-md-6 align-self-end",
                children: /*#__PURE__*/ _jsx("figure", {
                    className: "rounded",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "/img/photos/g2.jpg",
                        srcSet: "/img/photos/g2@2x.jpg 2x",
                        alt: ""
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-md-6 offset-md-1",
                children: /*#__PURE__*/ _jsx("figure", {
                    className: "rounded",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "/img/photos/g3.jpg",
                        srcSet: "/img/photos/g3@2x.jpg 2x",
                        alt: ""
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-md-4 align-self-start",
                children: /*#__PURE__*/ _jsx("figure", {
                    className: "rounded",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "/img/photos/g4.jpg",
                        srcSet: "/img/photos/g4@2x.jpg 2x",
                        alt: ""
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var tiles_Tiles2 = ((/* unused pure expression or super */ null && (Tiles2)));

// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(17857);
;// CONCATENATED MODULE: ./src/components/elements/tiles/Tiles3.tsx


var Tiles3 = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gx-md-5 gy-5",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-md-6",
                children: /*#__PURE__*/ _jsx("figure", {
                    className: "rounded mt-md-10 position-relative",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "/img/photos/g5.jpg",
                        srcSet: "/img/photos/g5@2x.jpg 2x",
                        alt: ""
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-md-6",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "row gx-md-5 gy-5",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-12 order-md-2",
                            children: /*#__PURE__*/ _jsx("figure", {
                                className: "rounded",
                                children: /*#__PURE__*/ _jsx("img", {
                                    src: "/img/photos/g6.jpg",
                                    srcSet: "/img/photos/g6@2x.jpg 2x",
                                    alt: ""
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-10",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "card bg-pale-primary text-center",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "card-body py-11 counter-wrapper",
                                    children: [
                                        /*#__PURE__*/ _jsx("h3", {
                                            className: "counter text-nowrap",
                                            children: /*#__PURE__*/ _jsx(CountUp, {
                                                end: 5000,
                                                suffix: "+"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "mb-0",
                                            children: "Satisfied Customers"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var tiles_Tiles3 = ((/* unused pure expression or super */ null && (Tiles3)));

;// CONCATENATED MODULE: ./src/components/elements/tiles/Tiles4.tsx

var Tiles4_images = [
    {
        id: 1,
        className: "col-md-4 offset-md-2 align-self-end",
        image: {
            "1x": "/img/photos/g1.jpg",
            "2x": "/img/photos/g1@2x.jpg 2x"
        }
    },
    {
        id: 2,
        className: "col-md-6 align-self-end",
        image: {
            "1x": "/img/photos/g2.jpg",
            "2x": "/img/photos/g2@2x.jpg 2x"
        }
    },
    {
        id: 3,
        className: "col-md-6 offset-md-1",
        image: {
            "1x": "/img/photos/g3.jpg",
            "2x": "/img/photos/g3@2x.jpg 2x"
        }
    },
    {
        id: 4,
        className: "col-md-4 align-self-start",
        image: {
            "1x": "/img/photos/g4.jpg",
            "2x": "/img/photos/g4@2x.jpg 2x"
        }
    }
];
var Tiles4 = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "row gx-md-5 gy-5",
        children: Tiles4_images.map(function(param) {
            var id = param.id, className = param.className, image = param.image;
            return /*#__PURE__*/ _jsx("div", {
                className: className,
                children: /*#__PURE__*/ _jsx("figure", {
                    className: "rounded",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: image["1x"],
                        srcSet: image["2x"],
                        alt: ""
                    })
                })
            }, id);
        })
    });
};
/* harmony default export */ var tiles_Tiles4 = ((/* unused pure expression or super */ null && (Tiles4)));

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/elements/tiles/Tiles5.tsx


var Tiles5 = function() {
    var images = [
        "about2",
        "about3"
    ];
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "shape bg-dot primary rellax w-16 h-20",
                style: {
                    top: "3rem",
                    left: "5.5rem"
                }
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "overlap-grid overlap-grid-2",
                children: images.map(function(item, i) {
                    return /*#__PURE__*/ _jsx("div", {
                        className: "item",
                        children: /*#__PURE__*/ _jsx("figure", {
                            className: "rounded shadow",
                            children: /*#__PURE__*/ _jsx("img", {
                                src: "/img/photos/".concat(item, ".jpg"),
                                srcSet: "/img/photos/".concat(item, "@2x.jpg 2x"),
                                alt: item
                            })
                        })
                    }, item + i);
                })
            })
        ]
    });
};
/* harmony default export */ var tiles_Tiles5 = ((/* unused pure expression or super */ null && (Tiles5)));

;// CONCATENATED MODULE: ./src/components/elements/tiles/Tiles6.tsx



var Tiles6 = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "row gx-0 mb-16 mb-mb-20",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "col-9 col-sm-10 col-lg-9 mx-auto mt-n15 mt-md-n20",
            children: [
                /*#__PURE__*/ _jsx("img", {
                    alt: "hero",
                    src: "/img/photos/sa1.jpg",
                    srcSet: "/img/photos/sa1@2x.jpg 2x",
                    className: "img-fluid mx-auto rounded shadow-lg",
                    style: animation({
                        name: "slideInUp",
                        delay: "1500ms"
                    })
                }),
                /*#__PURE__*/ _jsx("img", {
                    alt: "demo",
                    src: "/img/photos/sa2.jpg",
                    className: "position-absolute rounded shadow-lg",
                    style: _object_spread({
                        top: "20%",
                        right: "-10%",
                        maxWidth: "30%",
                        height: "auto"
                    }, animation({
                        name: "slideInRight",
                        delay: "1800ms"
                    }))
                }),
                /*#__PURE__*/ _jsx("img", {
                    alt: "demo",
                    src: "/img/photos/sa3.jpg",
                    className: "position-absolute rounded shadow-lg",
                    style: _object_spread({
                        top: "10%",
                        left: "-10%",
                        maxWidth: "30%",
                        height: "auto"
                    }, animation({
                        name: "slideInLeft",
                        delay: "2100ms"
                    }))
                }),
                /*#__PURE__*/ _jsx("img", {
                    alt: "demo",
                    src: "/img/photos/sa4.jpg",
                    className: "position-absolute rounded shadow-lg",
                    style: _object_spread({
                        left: "-13%",
                        bottom: "10%",
                        height: "auto",
                        maxWidth: "30%"
                    }, animation({
                        name: "slideInLeft",
                        delay: "2400ms"
                    }))
                })
            ]
        })
    });
};
/* harmony default export */ var tiles_Tiles6 = ((/* unused pure expression or super */ null && (Tiles6)));

;// CONCATENATED MODULE: ./src/components/elements/tiles/Tiles7.tsx


var Tiles7 = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "col-lg-6 position-relative",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "shape rounded bg-pale-red rellax d-block",
                style: {
                    zIndex: 0,
                    top: "50%",
                    left: "50%",
                    width: "50%",
                    height: "60%",
                    transform: "translate3d(0px, 0px, 0px) translate(-50%, -50%)"
                }
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row gx-md-5 gy-5 position-relative",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-6",
                        children: [
                            /*#__PURE__*/ _jsx("img", {
                                alt: "demo",
                                src: "/img/photos/sa5.jpg",
                                srcSet: "/img/photos/sa5@2x.jpg 2x",
                                className: "img-fluid rounded shadow-lg mb-5",
                                style: fadeInAnimate("300ms")
                            }),
                            /*#__PURE__*/ _jsx("img", {
                                alt: "demo",
                                src: "/img/photos/sa6.jpg",
                                srcSet: "/img/photos/sa6@2x.jpg 2x",
                                className: "img-fluid rounded shadow-lg d-flex col-10 ms-auto",
                                style: fadeInAnimate("600ms")
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-6",
                        children: [
                            /*#__PURE__*/ _jsx("img", {
                                alt: "demo",
                                src: "/img/photos/sa7.jpg",
                                srcSet: "/img/photos/sa7@2x.jpg 2x",
                                className: "img-fluid rounded shadow-lg my-5",
                                style: fadeInAnimate("900ms")
                            }),
                            /*#__PURE__*/ _jsx("img", {
                                alt: "demo",
                                src: "/img/photos/sa8.jpg",
                                srcSet: "/img/photos/sa8@2x.jpg 2x",
                                className: "img-fluid rounded shadow-lg d-flex col-10",
                                style: fadeInAnimate("1200ms")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var tiles_Tiles7 = ((/* unused pure expression or super */ null && (Tiles7)));

;// CONCATENATED MODULE: ./src/components/elements/tiles/Tiles8.tsx


// ====================================================
var Tiles8 = function(param) {
    var hiddenShape = param.hiddenShape;
    return /*#__PURE__*/ _jsxs("div", {
        className: "col-lg-6 position-relative order-lg-2",
        children: [
            !hiddenShape && /*#__PURE__*/ _jsx("div", {
                className: "shape rounded bg-pale-green rellax d-block",
                style: {
                    zIndex: 0,
                    top: "50%",
                    left: "50%",
                    width: "50%",
                    height: "60%",
                    transform: "translate3d(0px, 0px, 0px) translate(-50%, -50%)"
                }
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row gx-md-5 gy-5 position-relative",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-5",
                        children: [
                            /*#__PURE__*/ _jsx("img", {
                                alt: "demo",
                                src: "/img/photos/sa9.jpg",
                                srcSet: "/img/photos/sa9@2x.jpg 2x",
                                className: "img-fluid rounded shadow-lg my-5 d-flex ms-auto",
                                style: fadeInAnimate("300ms")
                            }),
                            /*#__PURE__*/ _jsx("img", {
                                alt: "",
                                src: "/img/photos/sa10.jpg",
                                srcSet: "/img/photos/sa10@2x.jpg 2x",
                                className: "img-fluid rounded shadow-lg d-flex col-10 ms-auto",
                                style: fadeInAnimate("600ms")
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-7",
                        children: [
                            /*#__PURE__*/ _jsx("img", {
                                alt: "demo",
                                src: "/img/photos/sa11.jpg",
                                srcSet: "/img/photos/sa11@2x.jpg 2x",
                                className: "img-fluid rounded shadow-lg mb-5",
                                style: fadeInAnimate("900ms")
                            }),
                            /*#__PURE__*/ _jsx("img", {
                                alt: "demo",
                                src: "/img/photos/sa12.jpg",
                                srcSet: "/img/photos/sa12@2x.jpg 2x",
                                className: "img-fluid rounded shadow-lg d-flex col-11",
                                style: fadeInAnimate("1200ms")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var tiles_Tiles8 = ((/* unused pure expression or super */ null && (Tiles8)));

;// CONCATENATED MODULE: ./src/components/elements/tiles/Tiles9.tsx


// ====================================================
var Tiles9 = function(param) {
    var hiddenShape = param.hiddenShape;
    return /*#__PURE__*/ _jsxs("div", {
        className: "col-lg-6 position-relative",
        children: [
            !hiddenShape && /*#__PURE__*/ _jsx("div", {
                className: "shape rounded bg-pale-yellow rellax d-block",
                style: {
                    zIndex: 0,
                    top: "50%",
                    left: "50%",
                    width: "50%",
                    height: "60%",
                    transform: "translate3d(0px, 0px, 0px) translate(-50%, -50%)"
                }
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row gx-md-5 gy-5 position-relative align-items-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-6",
                        children: /*#__PURE__*/ _jsx("img", {
                            alt: "",
                            src: "/img/photos/sa13.jpg",
                            srcSet: "/img/photos/sa13@2x.jpg 2x",
                            className: "img-fluid rounded shadow-lg d-flex ms-auto",
                            style: fadeInAnimate("300ms")
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-6",
                        children: [
                            /*#__PURE__*/ _jsx("img", {
                                alt: "",
                                src: "/img/photos/sa14.jpg",
                                srcSet: "/img/photos/sa14@2x.jpg 2x",
                                className: "img-fluid rounded shadow-lg mb-5",
                                style: fadeInAnimate("900ms")
                            }),
                            /*#__PURE__*/ _jsx("img", {
                                alt: "",
                                src: "/img/photos/sa15.jpg",
                                srcSet: "/img/photos/sa15@2x.jpg 2x",
                                className: "img-fluid rounded shadow-lg d-flex col-10",
                                style: fadeInAnimate("1200ms")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var tiles_Tiles9 = ((/* unused pure expression or super */ null && (Tiles9)));

;// CONCATENATED MODULE: ./src/components/elements/tiles/Tiles10.tsx

var Tiles10 = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gx-md-5 gy-5 align-items-center",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-md-6",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "row gx-md-5 gy-5",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-10 offset-md-2",
                            children: /*#__PURE__*/ _jsx("figure", {
                                className: "rounded",
                                children: /*#__PURE__*/ _jsx("img", {
                                    src: "/img/photos/ab1.jpg",
                                    srcSet: "/img/photos/ab1@2x.jpg 2x",
                                    alt: ""
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-12",
                            children: /*#__PURE__*/ _jsx("figure", {
                                className: "rounded",
                                children: /*#__PURE__*/ _jsx("img", {
                                    src: "/img/photos/ab2.jpg",
                                    srcSet: "/img/photos/ab2@2x.jpg 2x",
                                    alt: ""
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-md-6",
                children: /*#__PURE__*/ _jsx("figure", {
                    className: "rounded",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "/img/photos/ab3.jpg",
                        srcSet: "/img/photos/ab3@2x.jpg 2x",
                        alt: ""
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var tiles_Tiles10 = ((/* unused pure expression or super */ null && (Tiles10)));

;// CONCATENATED MODULE: ./src/components/elements/tiles/Tiles11.tsx

var Tiles11 = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gx-md-5 gy-5",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-md-6",
                children: /*#__PURE__*/ _jsx("figure", {
                    className: "rounded",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "/img/photos/g12.jpg",
                        srcSet: "/img/photos/g12@2x.jpg 2x",
                        alt: ""
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-md-6 align-self-end",
                children: /*#__PURE__*/ _jsx("figure", {
                    className: "rounded",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "/img/photos/g13.jpg",
                        srcSet: "/img/photos/g13@2x.jpg 2x",
                        alt: ""
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-12",
                children: /*#__PURE__*/ _jsx("figure", {
                    className: "rounded mx-md-5",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "/img/photos/g11.jpg",
                        srcSet: "/img/photos/g11@2x.jpg 2x",
                        alt: ""
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var tiles_Tiles11 = ((/* unused pure expression or super */ null && (Tiles11)));

;// CONCATENATED MODULE: ./src/components/elements/tiles/index.tsx














/***/ }),

/***/ 29190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports list, facts, blogList, teams, testimonialList, faq */
var list = (/* unused pure expression or super */ null && ([
    [
        "Aenean quam ornare. Curabitur blandit.",
        "Nullam quis risus eget urna mollis ornare."
    ],
    [
        "Etiam porta euismod malesuada mollis.",
        "Vivamus sagittis lacus vel augue rutrum."
    ]
]));
var facts = [
    {
        id: 1,
        amount: 7518,
        title: "Completed Projects"
    },
    {
        id: 2,
        amount: 3472,
        title: "Satisfied Customers"
    },
    {
        id: 3,
        amount: 2184,
        title: "Expert Employees"
    },
    {
        id: 4,
        amount: 4523,
        title: "Awards Won"
    }
];
var blogList = [
    {
        id: 1,
        category: "Coding",
        date: "14 Apr 2022",
        image: "/img/photos/b4.jpg",
        title: "Ligula tristique quis risus",
        description: "Mauris convallis non ligula non interdum. Gravida vulputate convallis tempus vestibulum cras imperdiet nun eu dolor."
    },
    {
        id: 2,
        category: "Workspace",
        date: "29 Mar 2022",
        image: "/img/photos/b5.jpg",
        title: "ullam id dolor elit id nibh",
        description: "Mauris convallis non ligula non interdum. Gravida vulputate convallis tempus vestibulum cras imperdiet nun eu dolor."
    },
    {
        id: 3,
        category: "Meeting",
        date: "26 Feb 2022",
        image: "/img/photos/b6.jpg",
        title: "Ultricies fusce porta elit",
        description: "Mauris convallis non ligula non interdum. Gravida vulputate convallis tempus vestibulum cras imperdiet nun eu dolor."
    },
    {
        id: 4,
        category: "Business Tips",
        date: "7 Jan 2022",
        image: "/img/photos/b7.jpg",
        title: "Morbi leo risus porta eget",
        description: "Mauris convallis non ligula non interdum. Gravida vulputate convallis tempus vestibulum cras imperdiet nun eu dolor."
    }
];
var teams = [
    {
        id: 1,
        name: "Coriss Ambady",
        designation: "Financial Analyst",
        image: {
            "1x": "/img/avatars/t1.jpg",
            "2x": "/img/avatars/t1@2x.jpg 2x"
        }
    },
    {
        id: 2,
        name: "Cory Zamora",
        designation: "Marketing Specialist",
        image: {
            "1x": "/img/avatars/t2.jpg",
            "2x": "/img/avatars/t2@2x.jpg 2x"
        }
    },
    {
        id: 3,
        name: "Nikolas Brooten",
        designation: "Sales Manager",
        image: {
            "1x": "/img/avatars/t3.jpg",
            "2x": "/img/avatars/t3@2x.jpg 2x"
        }
    },
    {
        id: 4,
        name: "Jackie Sanders",
        designation: "Investment Planner",
        image: {
            "1x": "/img/avatars/t4.jpg",
            "2x": "/img/avatars/t4@2x.jpg 2x"
        }
    }
];
var testimonialList = [
    {
        id: 1,
        name: "Coriss Ambady",
        image: "/img/avatars/te7.jpg",
        designation: "Financial Analyst",
        review: "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Vestibulum ligula porta felis euismod semper. Cras justo odio."
    },
    {
        id: 2,
        name: "Cory Zamora",
        image: "/img/avatars/te8.jpg",
        designation: "Marketing Specialist",
        review: "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Vestibulum ligula porta felis euismod semper. Cras justo odio."
    },
    {
        id: 3,
        name: "Barclay Widerski",
        image: "/img/avatars/te9.jpg",
        designation: "Sales Specialist",
        review: "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Vestibulum ligula porta felis euismod semper. Cras justo odio."
    }
];
var faq = [
    {
        id: 1,
        title: "Can I cancel my subscription?",
        description: "Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Etiam porta sem malesuada magna mollis euismod maecenas."
    },
    {
        id: 2,
        title: "Which payment methods do you accept?",
        description: "Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Etiam porta sem malesuada magna mollis euismod maecenas."
    },
    {
        id: 3,
        title: "How can I manage my Account?",
        description: "Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Etiam porta sem malesuada magna mollis euismod maecenas."
    },
    {
        id: 4,
        title: "Is my credit card information secure?",
        description: "Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Etiam porta sem malesuada magna mollis euismod maecenas."
    }
];



/***/ }),

/***/ 83152:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// UNUSED EXPORTS: factList, processList, reviews, services

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/icons/lineal/User.tsx

var User = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 441.4 512",
        xmlns: "http://www.w3.org/2000/svg",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-md text-primary mb-3"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M254.9 457c-14.9-8.1-24.1-23.7-24.1-40.6V285.6c26.5 11.1 57.1 4.9 77.1-15.6-19-26.2-49.3-41.6-81.6-41.6H115.7c-55.7 0-100.9 45.2-100.9 100.9v167.9h312.4v-.8L254.9 457z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M426.6 270.8c-8.2 0-14.8 6.6-14.9 14.8v130.7c0 11.5-6.3 22.1-16.4 27.6l-66.7 36.3-66.6-36.3c-10.1-5.5-16.4-16.1-16.4-27.6V305c4.1.6 8.2.9 12.3.9 1.3 0 2.5 0 3.8-.1h1c1.1-.1 2.2-.1 3.4-.2l1.6-.2 1.6-.2c15-2 29.3-8 41.1-17.5l1.1-.9 1.3-1.1c.9-.7 1.7-1.5 2.5-2.2l.4-.4c1-.9 1.9-1.8 2.8-2.7 3.8-3.9 7.2-8.1 10.1-12.6 7.2 10.9 16.8 19.9 28 26.5 7.1 4.1 16.2 1.8 20.3-5.3 4.1-7.1 1.8-16.2-5.3-20.3-10-5.9-17.9-14.8-22.6-25.5-2.4-5.4-7.7-8.8-13.6-8.9h-13.5c-5.9 0-11.2 3.5-13.6 8.9-.5 1-.9 2-1.4 3-12.8-12.4-28.4-21.7-45.4-27.2 17.4-16.5 27.2-39.4 27.2-63.3V87.5c-.2-8.2-7-14.7-15.2-14.5-7.9.2-14.3 6.6-14.5 14.5v68.3c0 31.6-25.5 57.4-57.1 57.8h-62c-31.6-.5-57-26.2-57-57.8V87.5c0-31.9 25.9-57.8 57.8-57.8h60.5c8.2-.2 14.7-7 14.5-15.2-.2-7.9-6.6-14.3-14.5-14.5h-60.5C92.5.1 53.3 39.2 53.3 87.5v68.3c0 23.9 9.8 46.8 27.2 63.3C32.6 234.5.1 279 0 329.3v167.9c0 8.2 6.6 14.8 14.8 14.8h313.9c2.5 0 4.9-.6 7.1-1.8l73.8-40.2c19.6-10.7 31.9-31.3 31.9-53.6V285.6c-.1-8.2-6.7-14.8-14.9-14.8zM29.7 482.3v-153c.1-47.5 38.5-85.9 86-86h40.4v144.1c0 8.2 6.6 14.8 14.8 14.8s14.8-6.6 14.8-14.8V243.3h40.4c22.6 0 44.3 9 60.4 24.8-6.3 3.9-13.3 6.4-20.6 7.5h.1c-1.1.2-2.3.3-3.5.4l-.6.1c-1.2.1-2.5.1-3.7.1h-.2c-7.3 0-14.6-1.4-21.4-4.3-7.5-3.2-16.3.3-19.4 7.9-.8 1.8-1.2 3.8-1.2 5.8v130.7c0 22.4 12.2 42.9 31.8 53.7l22.6 12.3H29.7z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M327.2 405.9c-2.5 0-5-.6-7.2-1.9l-24.9-13.9c-7.2-4-9.7-13-5.7-20.2s13-9.7 20.2-5.7l15.7 8.7 34.1-30.1c6.1-5.4 15.5-4.9 21 1.3 5.4 6.1 4.9 15.5-1.3 21l-42 37.1c-2.8 2.4-6.3 3.7-9.9 3.7z"
            })
        ]
    });
};
/* harmony default export */ var lineal_User = (User);

;// CONCATENATED MODULE: ./src/icons/lineal/Gift.tsx

var Gift = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 409.6 388.9",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-md text-blue mb-3"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M251.1 258.8l-44.3-22.9c-1.3-.6-2.7-.6-4 0l-44.4 22.9c-2.1 1.1-4.7.3-5.8-1.9-.3-.6-.5-1.3-.5-2v-113l105.4.2v112.8c0 2.4-1.9 4.3-4.3 4.3-.8 0-1.5-.1-2.1-.4z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M253.1 270.7c-2.5 0-5-.6-7.2-1.8l-41.1-21.2-41.1 21.2c-2.2 1.2-4.7 1.8-7.2 1.8-8.7 0-15.8-7.1-15.8-15.8v-113c0-6.3 5.1-11.5 11.5-11.5l105.3.2c6.3 0 11.4 5.1 11.4 11.5v112.8c0 8.7-7.1 15.8-15.8 15.8zm-48.3-46.8c2.5 0 5 .6 7.2 1.8l34 17.6v-89.6l-82.4-.2v89.8l34-17.6c2.3-1.2 4.7-1.8 7.2-1.8z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M319.5 388.9H90.1c-29.6 0-53.6-24-53.6-53.6V142.1c0-6.3 5.1-11.5 11.5-11.5h313.8c6.3 0 11.5 5.1 11.5 11.5v25.5c.2 6.3-4.8 11.6-11.1 11.8-6.3.2-11.6-4.8-11.8-11.1v-14.7H59.3v181.7c0 17 13.8 30.7 30.7 30.7h229.5c17 0 30.7-13.8 30.7-30.7V228.8c0-6.3 5.1-11.5 11.5-11.5 6.3 0 11.5 5.1 11.5 11.5v106.4c-.1 29.7-24.1 53.6-53.7 53.7z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M356.5 142.1H53.2c-23 0-41.7-18.7-41.7-41.7 0-23 18.7-41.7 41.7-41.7h303.3c23 0 41.7 18.7 41.7 41.7-.1 23-18.7 41.7-41.7 41.7z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M356.5 153.5H53.2C23.8 153.5 0 129.7 0 100.4s23.8-53.2 53.2-53.2h303.3c29.4 0 53.1 23.8 53.1 53.2s-23.8 53.1-53.1 53.1zM53.2 70.1c-16.7-.3-30.5 13-30.8 29.7s13 30.5 29.7 30.8h304.4c16.7.3 30.5-13 30.8-29.7.3-16.7-13-30.5-29.7-30.8H53.2z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M203.2 58.7c-5.8-31.3-35.8-52-67.1-46.3-23.5 4.3-42 22.7-46.3 46.3h113.4z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M203.2 70.1H89.8c-6.3 0-11.5-5.1-11.4-11.5 0-.7.1-1.3.2-2C85.4 19 121.4-5.9 158.9 1c28.3 5.2 50.4 27.3 55.6 55.6 1.1 6.2-3 12.2-9.2 13.3-.7.1-1.4.2-2.1.2zm-97.4-22.9h81.4c-12.1-22.5-40.2-30.9-62.6-18.8-8 4.3-14.5 10.9-18.8 18.8z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M319.8 58.7c-5.8-31.3-35.8-52-67.1-46.3-23.5 4.3-42 22.7-46.3 46.3h113.4z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M319.8 70.1H206.4c-6.3 0-11.4-5.1-11.4-11.4 0-.7.1-1.4.2-2C201.9 19 237.9-5.9 275.5 1c28.3 5.2 50.4 27.3 55.6 55.6 1.1 6.2-3 12.2-9.3 13.3-.6.1-1.3.2-2 .2zm-97.4-22.9h81.4c-12.1-22.5-40.2-30.9-62.6-18.8-8 4.3-14.5 10.9-18.8 18.8z"
            })
        ]
    });
};
/* harmony default export */ var lineal_Gift = (Gift);

// EXTERNAL MODULE: ./src/icons/lineal/Check.tsx
var Check = __webpack_require__(30009);
;// CONCATENATED MODULE: ./src/icons/lineal/IdCard.tsx

var IdCard = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 409.6 385",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-md text-orange mb-3"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M360.1 385H49.5C22.2 385 0 362.9 0 335.5V124.2c0-27.3 22.2-49.5 49.5-49.5h310.6c27.3 0 49.5 22.2 49.5 49.5v211.4c0 27.3-22.2 49.4-49.5 49.4zM49.5 97.6c-14.6 0-26.5 11.9-26.5 26.6v211.4c0 14.7 11.9 26.5 26.5 26.5h310.6c14.7 0 26.5-11.9 26.5-26.5V124.2c0-14.7-11.9-26.5-26.5-26.5l-310.6-.1z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M262.6 51.9h-16.5c-.5-22.8-19.4-40.9-42.2-40.4-22.1.5-39.9 18.3-40.4 40.4H147c-18.9 0-34.2 15.3-34.2 34.2s15.3 34.2 34.2 34.2h115.6c18.9 0 34.2-15.3 34.2-34.2s-15.3-34.2-34.2-34.2z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M262.6 131.9H147c-25.2-.4-45.4-21.1-45-46.4.4-24.7 20.3-44.7 45-45h6.5c6.8-28.3 35.3-45.8 63.6-39 19.3 4.6 34.4 19.7 39 39h6.5c25.2.4 45.4 21.1 45 46.4-.4 24.6-20.3 44.6-45 45zM147 63.4c-12.6.3-22.5 10.7-22.3 23.2.3 12.2 10.1 22 22.3 22.3h115.6c12.6-.3 22.5-10.7 22.3-23.2-.3-12.2-10.1-22-22.3-22.3h-16.5c-6.2 0-11.3-5-11.5-11.2-.4-16.5-14.1-29.5-30.6-29.1-15.9.4-28.7 13.2-29.1 29.1-.1 6.2-5.2 11.2-11.5 11.2H147zm-4 234.3c-34.2-.1-61.9-28-61.7-62.3s28-61.9 62.3-61.7c5.3 0 10.5.7 15.6 2.1 6.1 1.6 9.8 7.9 8.1 14.1s-7.9 9.8-14.1 8.1c-20.8-5.6-42.3 6.7-47.9 27.6s6.7 42.3 27.6 47.9 42.3-6.7 47.9-27.6c.9-3.3 1.3-6.7 1.3-10.2.2-6.3 5.5-11.3 11.8-11.1 6.1.2 11 5.1 11.1 11.1 0 34.2-27.7 61.9-62 62z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M180.5 300.2c-11.3-7-24.3-10.6-37.5-10.6-39.6.1-71.7 32.2-71.8 71.9v10.7h143.7v-10.7c-.1-25.1-13.1-48.2-34.4-61.3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M214.9 383.6H71.2c-6.3 0-11.5-5.1-11.5-11.4v-10.7c.5-46 38.2-82.9 84.2-82.4 45.3.5 81.9 37.1 82.4 82.4v10.7c0 6.3-5.1 11.4-11.4 11.4zM82.6 360.7h120.8c-.4-33.3-27.8-60-61.2-59.6-32.7.4-59.1 26.8-59.6 59.6zm255.9-111.9h-76.9c-6.3-.2-11.3-5.5-11.1-11.8.2-6.1 5.1-11 11.1-11.1h76.9c6.3-.2 11.6 4.8 11.8 11.1.2 6.3-4.8 11.6-11.1 11.8h-.7zm0 82.6h-76.9c-6.4 0-11.5-5.1-11.5-11.5s5.1-11.5 11.5-11.5h76.9c6.4 0 11.5 5.1 11.5 11.5s-5.2 11.5-11.5 11.5z"
            })
        ]
    });
};
/* harmony default export */ var lineal_IdCard = (IdCard);

// EXTERNAL MODULE: ./src/icons/lineal/ChatTwo.tsx
var ChatTwo = __webpack_require__(92875);
// EXTERNAL MODULE: ./src/icons/lineal/Browser.tsx
var Browser = __webpack_require__(4630);
// EXTERNAL MODULE: ./src/types/demo-1.ts
var demo_1 = __webpack_require__(74516);
;// CONCATENATED MODULE: ./src/icons/lineal/BriefcaseTwo.tsx

var BriefcaseTwo = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 409.6 380.8",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-md text-primary mb-3"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M299.9 104.7h-23.8V56.5c0-18.1-14.6-32.7-32.7-32.7h-77.2c-18 0-32.7 14.7-32.7 32.7v48.2h-23.8V56.5C109.8 25.3 135 0 166.2 0h77.2c31.2 0 56.4 25.3 56.5 56.5v48.2z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M360.5 380.8H49.1c-27.1 0-49-22-49.1-49.1V119.1C0 92 22 70 49.1 70h311.5c27.1 0 49 22 49.1 49.1v212.7c-.1 27.1-22.1 49-49.2 49zM49.1 93.8c-14 0-25.3 11.3-25.3 25.3v212.7c0 14 11.3 25.3 25.3 25.3h311.5c14 0 25.3-11.3 25.3-25.3V119.1c0-14-11.3-25.3-25.3-25.3H49.1z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M49.2 81.7c-18.4 0-33.3 14.8-33.3 33.2 0 2.7.3 5.3.9 7.9C35.4 197.9 103.6 254 184.2 254h41.2c80.6 0 148.8-56.1 167.3-131.2 4.3-17.8-6.6-35.8-24.5-40.2-2.6-.6-5.2-.9-7.9-.9H49.2z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M225.4 265.9h-41.2c-41.5-.1-81.8-14.2-114.3-40C38 200.5 15.3 165.2 5.4 125.6-.5 101.4 14.3 77 38.6 71.1c3.5-.9 7.1-1.3 10.7-1.3h311.1c24.9 0 45.2 20.2 45.2 45.1 0 3.6-.4 7.2-1.3 10.7-9.9 39.6-32.6 74.8-64.5 100.2-32.6 25.9-72.9 40-114.4 40.1zM49.2 93.6c-6.6 0-12.9 3-16.9 8.2-4.1 5.1-5.5 11.8-3.9 18.2 17.6 71.8 81.9 122.3 155.8 122.2h41.2c73.9.1 138.3-50.4 155.8-122.2 1.6-6.3.1-13-3.9-18.1-4.1-5.2-10.3-8.3-16.9-8.2l-311.2-.1z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M128.5 288.5h-13.8c-8.9 0-16.1-7.2-16.1-16.1v-48.3c0-8.9 7.2-16.1 16.1-16.1h13.8c8.9 0 16.1 7.2 16.1 16.1v48.3c0 8.9-7.2 16.1-16.1 16.1z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M128.5 300.4h-13.8c-15.5 0-28-12.5-28-28v-48.3c0-15.5 12.5-28 28-28h13.8c15.5 0 28 12.5 28 28v48.3c0 15.5-12.5 28-28 28zm-13.8-80.5c-2.3 0-4.2 1.9-4.2 4.2v48.3c0 2.3 1.9 4.2 4.2 4.2h13.8c2.3 0 4.2-1.9 4.2-4.2v-48.3c0-2.3-1.9-4.2-4.2-4.2h-13.8z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-fill",
                d: "M294.9 288.5h-13.8c-8.9 0-16.1-7.2-16.1-16.1v-48.3c0-8.9 7.2-16.1 16.1-16.1h13.8c8.9 0 16.1 7.2 16.1 16.1v48.3c0 8.9-7.2 16.1-16.1 16.1z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "lineal-stroke",
                d: "M294.9 300.4h-13.8c-15.5 0-28-12.5-28-28v-48.3c0-15.5 12.5-28 28-28h13.8c15.5 0 28 12.5 28 28v48.3c0 15.5-12.5 28-28 28zm-13.8-80.5c-2.3 0-4.2 1.9-4.2 4.2v48.3c0 2.3 1.9 4.2 4.2 4.2h13.8c2.3 0 4.2-1.9 4.2-4.2v-48.3c0-2.3-1.9-4.2-4.2-4.2h-13.8z"
            })
        ]
    });
};
/* harmony default export */ var lineal_BriefcaseTwo = (BriefcaseTwo);

;// CONCATENATED MODULE: ./src/data/demo-12.ts








var services = [
    {
        id: 1,
        link: "#",
        Icon: Browser/* default */.Z,
        title: "Content Marketing",
        linkType: demo_1/* LinkType.yellow */.U.yellow,
        iconClassName: "icon-svg-md text-yellow mb-3",
        cardClassName: "card-border-bottom border-soft-yellow",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget metus cras justo."
    },
    {
        id: 2,
        link: "#",
        Icon: ChatTwo/* default */.Z,
        title: "Social Engagement",
        linkType: demo_1/* LinkType.green */.U.green,
        iconClassName: "icon-svg-md text-green mb-3",
        cardClassName: "card-border-bottom border-soft-green",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget metus cras justo."
    },
    {
        id: 3,
        link: "#",
        Icon: lineal_IdCard,
        linkType: demo_1/* LinkType.orange */.U.orange,
        title: "Identity & Branding",
        iconClassName: "icon-svg-md text-orange mb-3",
        cardClassName: "card-border-bottom border-soft-orange",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget metus cras justo."
    },
    {
        id: 4,
        link: "#",
        Icon: lineal_Gift,
        linkType: demo_1/* LinkType.blue */.U.blue,
        title: "Product Design",
        iconClassName: "icon-svg-md text-blue mb-3",
        cardClassName: "card-border-bottom border-soft-blue",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida at eget metus cras justo."
    }
];
var processList = [
    {
        no: "1",
        className: "me-lg-6",
        title: "Collect Ideas",
        subtitle: "Nulla vitae elit libero pharetra augue dapibus. Praesent commodo cursus."
    },
    {
        no: "2",
        title: "Data Analysis",
        className: "ms-lg-13 mt-6",
        subtitle: "Vivamus sagittis lacus vel augue laoreet. Etiam porta sem malesuada magna."
    },
    {
        no: "3",
        title: "Finalize Product",
        className: "mx-lg-6 mt-6",
        subtitle: "Cras mattis consectetur purus sit amet. Aenean lacinia bibendum nulla sed."
    }
];
var factList = [
    {
        id: 1,
        number: 7518,
        title: "Completed Projects",
        Icon: Check/* default */.Z
    },
    {
        id: 2,
        number: 3472,
        title: "Happy Customers",
        Icon: lineal_User
    },
    {
        id: 3,
        number: 2184,
        title: "Expert Employees",
        Icon: lineal_BriefcaseTwo
    }
];
var reviews = [
    {
        id: 1,
        name: "Coriss Ambady",
        designation: "Financial Analyst",
        review: "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Vestibulum id ligula porta. Cras mattis consectetur."
    },
    {
        id: 2,
        name: "Cory Zamora",
        designation: "Marketing Specialist",
        review: "Fusce dapibus, tellus ac cursus tortor mauris condimentum fermentum massa justo sit amet purus sit amet fermentum."
    },
    {
        id: 3,
        name: "Nikolas Brooten",
        designation: "Sales Manager",
        review: "Curabitur blandit tempus porttitor. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor eu rutrum. Nulla vitae libero."
    },
    {
        id: 4,
        name: "Coriss Ambady",
        designation: "Financial Analyst",
        review: "Etiam adipiscing tincidunt elit convallis felis suscipit ut. Phasellus rhoncus eu tincidunt auctor nullam rutrum, pharetra augue."
    }
];



/***/ }),

/***/ 88231:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/icons/solid-mono/Code.tsx

var Code = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 255.98 213.34",
        className: "svg-inject icon-svg solid-mono ".concat(className || "icon-svg-md text-grape mb-5"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "fill-secondary",
                        d: "M104,213.34a11,11,0,0,1-2.59-.32,10.64,10.64,0,0,1-7.76-12.93l48-192a10.66,10.66,0,0,1,20.68,5.17l-48,192A10.66,10.66,0,0,1,104,213.34Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "fill-primary",
                        d: "M74.66,181.34a10.57,10.57,0,0,1-7.54-3.12l-64-64a10.67,10.67,0,0,1,0-15.08l64-64A10.67,10.67,0,0,1,82.21,50.22L25.75,106.69l56.46,56.46a10.65,10.65,0,0,1-7.55,18.19Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "fill-primary",
                        d: "M181.31,181.34a10.55,10.55,0,0,1-7.53-3.12,10.67,10.67,0,0,1,0-15.08l56.46-56.47L173.78,50.21a10.67,10.67,0,1,1,15.08-15.09l64,64a10.68,10.68,0,0,1,0,15.09l-64,64A10.58,10.58,0,0,1,181.31,181.34Z"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var solid_mono_Code = (Code);

;// CONCATENATED MODULE: ./src/icons/solid-mono/Team.tsx

var Team = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 255.98 256",
        className: "svg-inject icon-svg solid-mono ".concat(className || "icon-svg-md text-grape mb-5"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: "fill-primary",
                        cx: "128",
                        cy: "26.67",
                        r: "26.67"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: "fill-primary",
                        cx: "202.67",
                        cy: "176",
                        r: "26.67"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: "fill-primary",
                        cx: "53.33",
                        cy: "176",
                        r: "26.67"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "fill-primary",
                        d: "M173.33,106.67H82.66a8,8,0,0,1-8-8V93.34A29.35,29.35,0,0,1,104,64h48a29.35,29.35,0,0,1,29.33,29.32v5.33A8,8,0,0,1,173.33,106.67Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "fill-primary",
                        d: "M248,256H157.33a8,8,0,0,1-8-8v-5.33a29.36,29.36,0,0,1,29.33-29.33h48A29.36,29.36,0,0,1,256,242.67V248A8,8,0,0,1,248,256Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "fill-primary",
                        d: "M98.67,256H8a8,8,0,0,1-8-8v-5.33a29.36,29.36,0,0,1,29.33-29.33h48a29.37,29.37,0,0,1,29.33,29.33V248a8,8,0,0,1-8,8Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "fill-secondary",
                        d: "M29.33,136.13a8,8,0,0,1-8-8A107.1,107.1,0,0,1,83.06,31.36a8,8,0,1,1,6.73,14.51,91,91,0,0,0-52.48,82.26A8,8,0,0,1,29.33,136.13Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "fill-secondary",
                        d: "M226.67,136.13a8,8,0,0,1-8-8,91,91,0,0,0-52.48-82.26,8,8,0,1,1,6.74-14.51,107.09,107.09,0,0,1,61.73,96.77,8,8,0,0,1-8,8Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "fill-secondary",
                        d: "M128,234.8a105.08,105.08,0,0,1-11.15-.58,8,8,0,0,1,1.66-15.9,93.73,93.73,0,0,0,19.6-.06,8,8,0,0,1,1.76,15.9,110.68,110.68,0,0,1-11.87.64Z"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var solid_mono_Team = (Team);

// EXTERNAL MODULE: ./src/icons/solid-mono/Bulb.tsx
var Bulb = __webpack_require__(50417);
// EXTERNAL MODULE: ./src/icons/solid-mono/Lamp.tsx
var Lamp = __webpack_require__(13521);
// EXTERNAL MODULE: ./src/icons/solid-mono/Puzzle.tsx
var Puzzle = __webpack_require__(15992);
;// CONCATENATED MODULE: ./src/icons/solid-mono/Devices.tsx

var Devices = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 256",
        className: "svg-inject icon-svg solid-mono ".concat(className || "icon-svg-md text-grape mb-5"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "fill-primary",
                        d: "M226.67,0H80A29.35,29.35,0,0,0,50.67,29.33V42.66H72v-8A13.34,13.34,0,0,1,85.33,21.33h136a13.34,13.34,0,0,1,13.33,13.33V221.33a13.35,13.35,0,0,1-13.33,13.33H138.59A44.07,44.07,0,0,1,132.7,256h94A29.33,29.33,0,0,0,256,226.67V29.33A29.35,29.35,0,0,0,226.67,0Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "fill-secondary",
                        d: "M97.17,64h-77C9,64,0,73.87,0,86V234c0,12.13,9,22,20.16,22h77c11.12,0,20.16-9.87,20.16-22V86C117.33,73.87,108.29,64,97.17,64Zm5.5,168c0,4.42-3.28,8-7.33,8H22c-4.05,0-7.33-3.58-7.33-8V85.33c0-4.42,3.28-8,7.33-8h3.66c4.05,0,7.33,3.58,7.33,8s3.28,8,7.33,8H77c4.05,0,7.33-3.59,7.33-8s3.28-8,7.33-8h3.66c4,0,7.33,3.58,7.33,8V232Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "fill-primary",
                        d: "M154.67,186.67A13.33,13.33,0,1,0,168,200,13.35,13.35,0,0,0,154.67,186.67Z"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var solid_mono_Devices = (Devices);

;// CONCATENATED MODULE: ./src/icons/solid-mono/GlobeTwo.tsx

var GlobeTwo = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256.01 256",
        className: "svg-inject icon-svg solid-mono ".concat(className || "icon-svg-md text-grape mb-5"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "fill-secondary",
                        d: "M128.11,256V256h-.24a126.37,126.37,0,0,1-22-1.84,8,8,0,1,1,2.72-15.76A114.68,114.68,0,0,0,128,240a8.06,8.06,0,0,1,8.07,8,8,8,0,0,1-7.94,8Zm33.52-12.5a8,8,0,0,1,4.77-10.25A112.18,112.18,0,0,0,184.06,225a8,8,0,0,1,8,13.85,128.36,128.36,0,0,1-20.19,9.46,8,8,0,0,1-10.26-4.79Zm-97.5-4.56a128.83,128.83,0,0,1-18.27-12.78,8,8,0,1,1,10.25-12.27,114.33,114.33,0,0,0,16,11.2,8,8,0,1,1-8,13.85Zm150.69-27.71a8,8,0,0,1-1-11.26A112.91,112.91,0,0,0,225,184a8,8,0,0,1,13.86,8,130.3,130.3,0,0,1-12.78,18.26,8,8,0,0,1-11.28,1Zm-197.59-19A128.41,128.41,0,0,1,7.76,172a8,8,0,1,1,15-5.49,112.8,112.8,0,0,0,8.29,17.67,8,8,0,1,1-13.84,8ZM244.8,156.7a8,8,0,0,1-6.5-9.26A112.3,112.3,0,0,0,240,128a8.23,8.23,0,0,1,8-8.26,7.81,7.81,0,0,1,8,8.76,124.89,124.89,0,0,1-1.92,21.72,8,8,0,0,1-9.26,6.48ZM8,136.13a7.89,7.89,0,0,1-8-7.87s.61-15,1.86-22.18a8,8,0,1,1,15.76,2.7A114.47,114.47,0,0,0,16,128,8.09,8.09,0,0,1,8,136.13ZM233.1,89.25a110.41,110.41,0,0,0-8.32-17.63,8,8,0,0,1,13.83-8.08,129,129,0,0,1,9.52,20.17,8,8,0,0,1-15,5.54ZM19.9,75.18A8,8,0,0,1,17,64.26,126.41,126.41,0,0,1,29.73,46,8,8,0,1,1,42,56.21a112.72,112.72,0,0,0-11.17,16,8,8,0,0,1-10.93,3ZM199.66,41.94a113.17,113.17,0,0,0-16-11.16,8,8,0,1,1,7.95-13.87,127.39,127.39,0,0,1,18.3,12.75,8,8,0,0,1-10.24,12.28ZM60.78,28.26a8,8,0,0,1,2.88-11A128,128,0,0,1,83.84,7.82a8,8,0,1,1,5.52,15,112.17,112.17,0,0,0-17.63,8.31,8,8,0,0,1-11-2.88Zm86.29-10.64A112.4,112.4,0,0,0,128,16a8.17,8.17,0,0,1-8.19-8,7.84,7.84,0,0,1,7.81-8H128a127.72,127.72,0,0,1,21.8,1.86,8,8,0,0,1-2.71,15.76Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "fill-primary",
                        d: "M128,32a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,32Zm62.61,145.66a103,103,0,0,0-14.49-7.76,160.22,160.22,0,0,0,5-33.9h26.48A79.47,79.47,0,0,1,190.59,177.66ZM48.4,136H74.88a161.6,161.6,0,0,0,5,33.9,104.11,104.11,0,0,0-14.5,7.76A79.47,79.47,0,0,1,48.4,136Zm17-57.66a103.14,103.14,0,0,0,14.5,7.76,160.2,160.2,0,0,0-5,33.9H48.4a79.47,79.47,0,0,1,17-41.66ZM120,79.7a106.49,106.49,0,0,1-20-3.43c5.41-13,12.6-22.11,20-26Zm0,16V120H90.86A145.12,145.12,0,0,1,95,91.49a122.72,122.72,0,0,0,25,4.21Zm0,40.3v24.3a121.26,121.26,0,0,0-25,4.23A144.37,144.37,0,0,1,90.86,136H120Zm0,40.3v29.48c-7.4-3.94-14.59-13-20-26a104.12,104.12,0,0,1,20-3.44Zm16,0a106.21,106.21,0,0,1,20,3.43c-5.4,13-12.59,22.11-20,26Zm0-16V136H165.1a144.37,144.37,0,0,1-4.16,28.51,122.49,122.49,0,0,0-25-4.21Zm0-40.3V95.7a121.14,121.14,0,0,0,25-4.23A142.91,142.91,0,0,1,165.1,120H136Zm0-40.3V50.24c7.41,3.94,14.6,13,20,26A104.36,104.36,0,0,1,136,79.7Zm27.94-23.08a80.19,80.19,0,0,1,15.25,10A88.15,88.15,0,0,1,171,70.83a98.1,98.1,0,0,0-7.12-14.21Zm-79,14.21a86.72,86.72,0,0,1-8.12-4.25,80.12,80.12,0,0,1,15.24-10A95.14,95.14,0,0,0,84.94,70.83Zm0,114.34a98.11,98.11,0,0,0,7.12,14.21,80.12,80.12,0,0,1-15.24-10A86.72,86.72,0,0,1,84.94,185.17Zm86.1,0a88.15,88.15,0,0,1,8.13,4.25,80.19,80.19,0,0,1-15.25,10A99.14,99.14,0,0,0,171,185.17ZM181.1,120a161,161,0,0,0-5-33.9,104.57,104.57,0,0,0,14.49-7.76,79.47,79.47,0,0,1,17,41.66Z"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var solid_mono_GlobeTwo = (GlobeTwo);

// EXTERNAL MODULE: ./src/icons/solid-mono/Headphone.tsx
var Headphone = __webpack_require__(89033);
;// CONCATENATED MODULE: ./src/data/demo-26.ts








var serviceList = [
    {
        id: 1,
        url: "#",
        Icon: solid_mono_GlobeTwo,
        title: "SEO Services",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida eget metus cras justo."
    },
    {
        id: 2,
        url: "#",
        Icon: solid_mono_Code,
        title: "Web Design",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida eget metus cras justo."
    },
    {
        id: 3,
        url: "#",
        Icon: solid_mono_Team,
        title: "Social Engagement",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida eget metus cras justo."
    },
    {
        id: 4,
        url: "#",
        Icon: solid_mono_Devices,
        title: "App Development",
        description: "Nulla vitae elit libero, a pharetra augue. Donec id elit non mi porta gravida eget metus cras justo."
    }
];
var abouts = [
    {
        id: 1,
        Icon: Lamp/* default */.Z,
        title: "Creativity",
        description: "Curabitur blandit lacus porttitor ridiculus mus."
    },
    {
        id: 2,
        Icon: Bulb/* default */.Z,
        title: "Innovative Thinking",
        description: "Curabitur blandit lacus porttitor ridiculus mus."
    },
    {
        id: 3,
        Icon: Puzzle/* default */.Z,
        title: "Rapid Solutions",
        description: "Curabitur blandit lacus porttitor ridiculus mus."
    },
    {
        id: 4,
        Icon: Headphone/* default */.Z,
        title: "Top-Notch Support",
        description: "Curabitur blandit lacus porttitor ridiculus mus."
    }
];
var testimonialList = [
    {
        id: 1,
        name: "Coriss Ambady",
        designation: "Financial Analyst",
        review: "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Vestibulum ligula porta\n    felis euismod semper. Cras justo odio consectetur nulla dapibus curabitur blandit faucibus."
    },
    {
        id: 2,
        name: "Cory Zamora",
        designation: "Marketing Specialist",
        review: "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Vestibulum ligula porta\n    felis euismod semper. Cras justo odio consectetur nulla dapibus curabitur blandit faucibus."
    },
    {
        id: 3,
        name: "Nikolas Brooten",
        designation: "Sales Specialist",
        review: "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Vestibulum ligula porta\n    felis euismod semper. Cras justo odio consectetur nulla dapibus curabitur blandit faucibus."
    }
];
/* harmony default export */ var demo_26 = ({
    serviceList: serviceList,
    abouts: abouts,
    testimonialList: testimonialList
});


/***/ }),

/***/ 4630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Browser = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        viewBox: "0 0 512 442.8",
        xmlns: "http://www.w3.org/2000/svg",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-md text-red mb-3"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M464.2 442.8H47.7C21.4 442.8 0 421.4 0 395.1V47.7C0 21.4 21.4 0 47.7 0h416.5C490.6 0 512 21.4 512 47.7c0 7.6-6.2 13.8-13.8 13.9-7.6 0-13.8-6.2-13.9-13.8 0-11.1-9-20-20.1-20.1H47.7c-11.1 0-20 9-20.1 20.1v347.3c0 11.1 9 20.1 20.1 20.1h416.5c11.1 0 20.1-9 20.1-20.1V209.4c0-7.6 6.2-13.8 13.8-13.9 7.6 0 13.8 6.2 13.9 13.8V395c0 26.4-21.4 47.8-47.8 47.8z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-fill",
                d: "M13.8 47.7v69.9h484.3V47.7c0-18.7-15.2-33.9-33.9-33.9H47.7C29 13.8 13.8 29 13.8 47.7z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M498.2 131.5H13.8c-7.6 0-13.8-6.2-13.8-13.8v-70C0 21.4 21.4 0 47.7 0h416.5C490.6 0 512 21.4 512 47.7v69.9c0 7.7-6.2 13.9-13.8 13.9zM27.7 103.8h456.6v-56c0-11.1-9-20.1-20.1-20.1H47.8c-11.1 0-20 9-20.1 20v56.1z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M294.7 79.6h-26.3c-7.6 0-13.8-6.2-13.8-13.8S260.8 52 268.4 52h26.3c7.6 0 13.8 6.2 13.8 13.8.1 7.6-6.1 13.8-13.8 13.8zm73.4 0h-26.3c-7.6 0-13.8-6.2-13.8-13.8 0-7.6 6.2-13.8 13.8-13.8h26.3c7.6 0 13.8 6.2 13.8 13.8 0 7.6-6.2 13.8-13.8 13.8zm73.3 0h-26.3c-7.6 0-13.8-6.2-13.8-13.8 0-7.6 6.2-13.8 13.8-13.8h26.3c7.6 0 13.8 6.2 13.8 13.8.1 7.6-6.1 13.8-13.8 13.8z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-fill",
                d: "M112.8 268.5h286.4v63.6H112.8z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M399.2 345.9H112.8c-7.6 0-13.8-6.2-13.8-13.8v-63.7c0-7.6 6.2-13.8 13.8-13.8h286.4c7.6 0 13.8 6.2 13.8 13.8v63.7c.1 7.6-6.1 13.8-13.8 13.8zm-272.6-27.6h258.8v-36H126.6v36zm230.9-95.5h-203c-7.6.2-14-5.8-14.2-13.5s5.8-14 13.5-14.2h203.8c7.6-.2 14 5.8 14.2 13.5s-5.8 14-13.5 14.2h-.8z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Browser);


/***/ }),

/***/ 92875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var ChatTwo = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        viewBox: "0 0 512 454.6",
        xmlns: "http://www.w3.org/2000/svg",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-md text-green mb-3"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-fill",
                d: "M131.5 126.8h249V15.2H15.2v256.3h116.3z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M496.8 194.4c-8.4 0-15.2 6.8-15.2 15.2v158.3h-29.7c-8.4 0-15.2 6.8-15.2 15.2 0 .5 0 1.1.1 1.6l2.8 27.2-75.7-42.1c-2.3-1.3-4.8-1.9-7.4-1.9H146.7V142h233.8c8.4 0 15.2-6.8 15.2-15.2V15.2c0-8.4-6.8-15.2-15.2-15.2H15.2C6.8 0 0 6.8 0 15.2v256.3c0 8.4 6.8 15.2 15.2 15.2h101v96.4c0 8.4 6.8 15.2 15.2 15.2h221l97.8 54.3c7.3 4.1 16.6 1.4 20.7-5.9 1.5-2.7 2.2-5.9 1.8-9l-4.1-39.5h28.1c8.4 0 15.2-6.8 15.2-15.2V209.6c.1-8.4-6.7-15.2-15.1-15.2zM30.4 256.3V30.4h334.8v81.2H131.5c-8.4 0-15.2 6.8-15.2 15.2v129.5H30.4z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M413.8 223.6H214.4c-8.4 0-15.2-6.8-15.2-15.2s6.8-15.2 15.2-15.2h199.4c8.4 0 15.2 6.8 15.2 15.2s-6.8 15.2-15.2 15.2zm0 85.9H214.4c-8.4 0-15.2-6.8-15.2-15.2S206 279 214.4 279h199.4c8.4 0 15.2 6.8 15.2 15.2s-6.8 15.3-15.2 15.3z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ChatTwo);


/***/ }),

/***/ 30009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Check = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        viewBox: "0 0 409.6 409.6",
        xmlns: "http://www.w3.org/2000/svg",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-md text-primary mb-3"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M204.8 409.6C91.9 409.6 0 317.7 0 204.8c0-49.9 18.2-98.1 51.2-135.5 4.4-5 12-5.5 17-1.1s5.5 12 1.1 17c-29.1 33-45.2 75.5-45.2 119.5 0 99.6 81.1 180.7 180.7 180.7s180.7-81.1 180.7-180.7S304.4 24.1 204.8 24.1c-27.3-.1-54.2 6.1-78.7 18-6 2.9-13.2.4-16.1-5.6-2.9-6-.4-13.2 5.6-16.1C143.4 6.9 173.9-.1 204.8 0c112.9 0 204.8 91.9 204.8 204.8s-91.9 204.8-204.8 204.8z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-fill",
                d: "M349.4 204.8c0 79.8-64.7 144.6-144.6 144.6S60.2 284.6 60.2 204.8 125 60.2 204.8 60.2 349.4 125 349.4 204.8z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M204.8 361.4c-86.4 0-156.6-70.2-156.6-156.6S118.4 48.2 204.8 48.2s156.6 70.2 156.6 156.6-70.2 156.6-156.6 156.6zm0-289.1c-73.1 0-132.5 59.4-132.5 132.5s59.4 132.5 132.5 132.5 132.5-59.5 132.5-132.5S277.9 72.3 204.8 72.3z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M200.9 246.7c-8.8 0-17.2-3.5-23.5-9.7L145 204.5c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l32.5 32.5c3.6 3.5 9.3 3.5 12.8 0l49.8-49.9c4.7-4.7 12.3-4.7 17 0s4.7 12.3 0 17L224.4 237c-6.2 6.2-14.7 9.7-23.5 9.7z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Check);


/***/ }),

/***/ 50417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Bulb = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 255.98",
        className: "svg-inject icon-svg solid-mono ".concat(className || "icon-svg-sm text-fuchsia me-4"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                className: "fill-primary",
                cx: "58.67",
                cy: "149.31",
                r: "32"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "fill-primary",
                d: "M88 202.65H29.33A29.36 29.36 0 000 232v16a8 8 0 008 8h101.33a8 8 0 008-8v-16A29.36 29.36 0 0088 202.65z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                className: "fill-primary",
                cx: "197.33",
                cy: "149.31",
                r: "32"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "fill-primary",
                d: "M226.67 202.65H168A29.36 29.36 0 00138.67 232v16a8 8 0 008 8H248a8 8 0 008-8v-16a29.36 29.36 0 00-29.33-29.35z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "fill-secondary",
                d: "M149.76 108.48v7.68A11.9 11.9 0 01137.81 128h-19.63c-5.76 0-12-4.27-12-13.76v-5.76zM176 47.68a47.26 47.26 0 01-17.6 36.91 22.89 22.89 0 00-8.32 13.23H106a20 20 0 00-7.79-12.69A47.13 47.13 0 0180 46.73C80.53 21.34 101.76.33 127.25 0a47.34 47.34 0 0134.56 13.88A46.82 46.82 0 01176 47.68z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Bulb);


/***/ }),

/***/ 89033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Headphone = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 244.09",
        className: "svg-inject icon-svg solid-mono ".concat(className || "icon-svg-xs text-green me-4"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "fill-secondary",
                d: "M35.72 92.28a92.28 92.28 0 01184.56 0v47.63a8.93 8.93 0 01-17.86 0V92.28a74.42 74.42 0 10-148.84 0v47.63a8.93 8.93 0 11-17.86 0zm175.63 62.51a8.93 8.93 0 018.93 8.93v35.72a32.75 32.75 0 01-32.75 32.75h-35.72a8.94 8.94 0 010-17.87h35.72a14.88 14.88 0 0014.89-14.88v-35.72a8.93 8.93 0 018.93-8.93z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "fill-secondary",
                d: "M107.16 223.26A20.84 20.84 0 01128 202.42h11.91a20.84 20.84 0 010 41.67H128a20.84 20.84 0 01-20.84-20.83zm20.84-3a3 3 0 100 5.95h11.91a3 3 0 000-5.95z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "fill-primary",
                d: "M32.74 107.16A32.74 32.74 0 000 139.91v23.81a32.75 32.75 0 0032.74 32.75h11.91a8.93 8.93 0 008.93-8.94v-71.44a8.93 8.93 0 00-8.93-8.93zm190.52 0A32.74 32.74 0 01256 139.91v23.81a32.75 32.75 0 01-32.74 32.75h-11.91a8.93 8.93 0 01-8.93-8.94v-71.44a8.93 8.93 0 018.93-8.93z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Headphone);


/***/ }),

/***/ 13521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Lamp = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 256",
        className: "svg-inject icon-svg solid-mono ".concat(className || "icon-svg-sm text-orange mb-3"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "fill-secondary",
                d: "M128 36.86a8 8 0 01-8-8V8a8 8 0 0116 0v20.86a8 8 0 01-8 8zm70.1 29.04a8 8 0 01-5.67-13.64l14.77-14.77a8 8 0 1111.31 11.31l-14.77 14.77a8 8 0 01-5.64 2.33zM248 136h-20.86a8 8 0 010-16H248a8 8 0 010 16zm-35.15 84.85a8.06 8.06 0 01-5.67-2.34l-14.76-14.77a8 8 0 0111.31-11.31l14.77 14.77a8 8 0 010 11.31 7.92 7.92 0 01-5.65 2.34zm-169.7 0a8 8 0 01-5.66-13.65l14.77-14.77a8 8 0 0111.31 11.31L48.8 218.51a7.93 7.93 0 01-5.65 2.34zM28.86 136H8a8 8 0 010-16h20.86a8 8 0 110 16zM57.9 65.9a8 8 0 01-5.66-2.33L37.47 48.8a8 8 0 1111.31-11.31l14.77 14.77A8 8 0 0157.9 65.9z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "fill-primary",
                d: "M160 224v13.33A18.76 18.76 0 01141.33 256h-26.67c-9 0-18.66-6.83-18.66-21.76V224zm15-154a74.93 74.93 0 00-63-15c-28.27 5.91-51.2 29-57.07 57.21a74.74 74.74 0 0028.16 75.41A32.19 32.19 0 0195.25 208v.12A2 2 0 0196 208h64a.93.93 0 01.53.11V208c1.49-8.11 6.29-15.57 13.65-21.33A74.72 74.72 0 00175 70zm-7 63.36a8.06 8.06 0 01-8-8A29.32 29.32 0 00130.67 96a8 8 0 110-16A45.43 45.43 0 01176 125.33a8.06 8.06 0 01-8 8z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "fill-secondary",
                d: "M95.25 208H96a1.8 1.8 0 00-.75.11z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "fill-primary",
                d: "M160.53 208v.11a.93.93 0 00-.53-.11z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Lamp);


/***/ }),

/***/ 15992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Puzzle = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 255.97 256",
        className: "svg-inject icon-svg solid-mono ".concat(className || "icon-svg-xs text-orange me-4"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "fill-secondary",
                d: "M221.86 91a33.65 33.65 0 01-22.72-8.75v40.21h-27.2a43.26 43.26 0 003.73-17.71 44.8 44.8 0 10-86 17.71H56.85v-111A11.42 11.42 0 0168.26 0h119.47a11.42 11.42 0 0111.41 11.41v20.05A34.1 34.1 0 11221.86 91z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "fill-primary",
                d: "M142.79 181.25a34.13 34.13 0 0033.55 40.62 33.66 33.66 0 0022.75-8.77v31.52A11.41 11.41 0 01187.72 256H68.28a11.41 11.41 0 01-11.38-11.38V213.1a34.12 34.12 0 11-22.75-59.5 33.71 33.71 0 0122.75 8.77v-29.2H112a34.12 34.12 0 1137.76 0h49.37v29.2a34.09 34.09 0 00-56.3 18.88z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Puzzle);


/***/ }),

/***/ 74516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ LinkType; }
/* harmony export */ });
var LinkType;
(function(LinkType) {
    LinkType["red"] = "red";
    LinkType["blue"] = "blue";
    LinkType["green"] = "green";
    LinkType["yellow"] = "yellow";
    LinkType["violet"] = "violet";
    LinkType["orange"] = "orange";
    LinkType["fuchsia"] = "fuchsia";
})(LinkType || (LinkType = {}));



/***/ })

}]);